<template>
  <div class="notify-wrap">
    <div class="notify-header">
      <span>消息通知（{{ msgList && msgList.length }}）</span>
      <div class="icon-box" @click="clearMsgList">
        <i class="iconfont icon-close pointer" />
      </div>
    </div>

    <div class="notify-content" v-infinite-scroll="loadMore">
      <div class="info-wrap">
        <div v-for="(item, i) in msgList.slice(0, count * unit)" :key="i" class="info-item">
          <div class="title">{{ item.mainTitle || '系统消息' }}</div>
          <div class="msg-content" v-html="item.content" />
          <div class="btn-wrap">
            <div
              class="btn1 pointer"
              v-if="item.showCheck ? item.showCheck === 'true' : true"
              @click="handleRead(item.fn, i, item.msgId)"
            >
              {{ item.text || '查看' }}
            </div>
            <div class="btn2 pointer" @click="handleDelete(i)">删除</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useSocketMsg } from '@/stores/modules/socketMsg'
import { usePayOrderInfo } from '@/stores/modules/pay'
const socketMsg = useSocketMsg()

const clearMsgList = socketMsg.clearMsgList
const deleteMsgList = socketMsg.deleteMsgList
const msgList = computed(() => socketMsg.msgList)

const unit = ref(50)
const count = ref(1)
function loadMore() {
  if (msgList.value.length / unit.value > count.value) {
    ++count.value
  }
}

function handleDelete(index: number) {
  deleteMsgList(index)
}

console.log('我被唤起了')

function handleRead(fn: any, index: number, msgId: number) {
  console.log(fn, index, msgId)
  deleteMsgList(index)
  fn && fn()
}
const toOrderPay = (event: any) => {
  usePayOrderInfo()?.refreshData(true)

  if (event?.target?.dataset?.mainorderid) {
    usePayOrderInfo()?.setPayOrderId([event.target.dataset.mainorderid])
  }
  // 处理消息弹窗消失
  if (event?.target?.dataset?.msgid) {
    const matchIndex = msgList.value.findIndex(ele => ele.msgId === event.target.dataset.msgid)
    if (matchIndex !== -1) {
      deleteMsgList(matchIndex)
    }
  }
}
onMounted(() => {
  window.toOrderPay = toOrderPay
})
</script>

<style lang="scss" scoped>
.notify-wrap {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 9999;
  width: 480px;
  background-color: #fff;
  box-shadow: 0 3px 14px 4px #00000024;
  border-radius: 4px;
  .notify-header {
    border-radius: 4px 4px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    color: #fff;
    background-color: #5687ff;
    padding-left: 24px;
    font-size: 14px;
    .icon-box {
      width: 58px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .notify-content {
    font-size: 14px;
    overflow: scroll;
    .info {
      border-bottom: 1px solid #ebeef5;
      padding: 24px;
      color: #333;
    }
    .title {
      font-weight: bold;
      margin-bottom: 10px;
      color: #000;
    }
    .msg-content {
      line-height: 22px;
    }
    .bottom {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 16px 24px;
      color: #5687ff;
    }
    .info-wrap {
      padding: 16px 24px;
      padding-bottom: 4px;
      max-height: 319px;
      .info-item {
        padding: 15px 0;
        border-bottom: 1px solid #ebeef5;
        &:last-child {
          border: none;
        }
      }
      .btn-wrap {
        display: flex;
        justify-content: flex-end;
        font-size: 12px;
        margin: 10px 0;
        .btn1 {
          color: #5687ff;
          margin-right: 16px;
        }
        .btn2 {
          color: #f44d4d;
        }
      }
    }
  }
}
</style>
